<template>
    <div>
        <rkm-form ref="formItens">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        v-if="repositories.material"
                        :disabled="statusIsFinalizado"
                        :repository="repositories.material"
                        :request-query-string-params="autocompleteQueryStringParams.material"
                        :search-fields="autocompleteFields.material"
                        :validations="validations.material"
                        label="Material"
                        text-field="descricaoCompleta"
                        uppercase
                        v-model="model.material"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :disabled="!model.material"
                        :validations="validations.quantidade"
                        label="Quantidade"
                        number
                        v-model="model.quantidade"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        :disabled="!model.material"
                        @click="$refs.formItens.validate(add)"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="model.itens"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :disabled="statusIsFinalizado"
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>
<script>

// Mixin.
import { repository, object } from '@/mixins'

// Enums.
import statusTipo from '@/enums/manutencao/statusTipo'

export default {
    computed: {
        autocompleteFields() {
            return {
                material: [
                    { key: 'cadastro_material.codigo_material', searchable: true },
                    { key: 'cadastro_material.descricao', searchable: true },
                ],
            };
        },
        autocompleteQueryStringParams() {

            return {
                material: {
                    not_id: (this.model?.itens || []).map(i => i.material?.id),
                    somente_material: true,
                }
            }
        },
        validations() {
            return {
                material: {
                    required: false,
                },
                quantidade: {
                    required: false,
                    max: 8,
                    min_value: 1,
                },
            };
        },
        fields() {

            const fields = this.getFields()

            return [
                fields.material,
                fields.quantidade,
                fields.actions
            ];
        },
        statusIsFinalizado() {

            return this.form.pedenteFinalizacao || this.form.statusTipoId === this.enums.statusTipo.CANCELADO;
        },
    },
    created() {
        this.repositories = {
            material: this.getConectaSusRepository('cadastro.material'),
        };
    },
    data: () => ({
        repositories: {},
        data: [],
        enums: { statusTipo },
    }),
    methods: {
        add() {

            const data = this.clone(this.model)

            this.model.itens.push({
                material: {
                    id: data.material.id,
                    codigo: data.material.codigoMaterial,
                    descricaoCompleta: data.material.descricaoCompleta,
                },
                quantidade: parseInt(this.model.quantidade),
            })

            this.resetForm()
        },
        resetForm() {

            this.model.material = null
            this.model.quantidade = 1

            this.$nextTick().then(() => this.$refs.formItens.resetValidator())
        },
        getFields() {

            return {
                material: {
                    key: 'material.descricaoCompleta',
                    label: 'Material',
                    sortable: true,
                },
                quantidade: {
                    key: 'quantidade',
                    label: 'Quantidade',
                    class: 'col-min text-center'
                },
                actions: {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                }
            }
        },
        destroy(item) {

            const index = this.model.itens.indexOf(item)

            if (index > -1) {
                this.model.itens.splice(index, 1)
            }
        },
    },
    mixins: [repository, object],
    props: {
        model: { type: [Array, Object], required: true, default: () => ({ itens: [] }) },
        form: { type: [Array, Object], required: true, default: () => ({}) },
    },
};
</script>
